import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

const TOKEN_KEY = 'token-avalservi';
const EXTERNAL_ACCESS_KEY = 'avalservi-external-access';

function validateAuth(stateUrl: string): boolean {
  const authSvc = inject(AuthService);
  const router = inject(Router);
  const url = new URL(stateUrl, window.location.origin);
  const externalToken = url.searchParams.get('t');
  const isExternal = url.searchParams.get('external') === '1';

  if (externalToken) {
    localStorage.setItem(TOKEN_KEY, externalToken);
  }

  if (isExternal) {
    localStorage.setItem(EXTERNAL_ACCESS_KEY, '1');
  }

  if (authSvc.isLogged()) {
    return true;
  }

  router.navigate(['/auth/iniciar-sesion']);
  return false;
};

export const AuthGuard: CanActivateFn = (_route, state) => validateAuth(state.url);

export const AuthChildGuard: CanActivateChildFn = (_childRoute, state) =>
  validateAuth(state.url);
